
import Order from './Order'
import Invoice from './Invoice'
import Payment from './Payment'
import OrderContent from './OrderContent'
import OrderStatus from './Static/OrderStatus'

export default class Refund extends Order {
  constructor ({id, opened, lockedBy, order, invoice, refund, tenantUser, voidReasons = [] }) {
    super({
      id,
      lockedBy,
      opened,
      closed: opened,
      status: OrderStatus.REFUND,
      tableName: order.tableName,
      table_id: order.table_id,
      tenantUser_id: tenantUser.id,
      tenantUserName: tenantUser.name,
      guests: 0,
      discount: order.discount && ! order.discount.isPercentage
        ? -order.discount
        : order.discount,
      refunded_invoice_id: invoice.id,
      cancelReason: invoice.cancelReason,
      notAccountable: invoice.notAccountable,
    })

    if (this._shouldRefundGuests(order.orderInvoices)) {
      this.guests = -order.guests
    }
    this.orderContents = this._refundedContents(order, invoice)
    this.orderInvoices = [this._refundedInvoice(invoice, refund, this.orderContents, voidReasons)]

    this.recalculate()
    this.linkInvoicesWithContents()
  }

  _shouldRefundGuests (invoices) {
    return invoices?.filter(invoice => ! invoice.refunded).length === 1
  }

  _refundedContents (order, invoice) {
    return order.orderContents
      .filter(content => invoice.orderContentsIds.includes(content.id))
      .map(content => this._refundedContent(content))
  }

  _refundedContent (content) {
    return new OrderContent({
      ...content,
      id: null,
      quantity: -content.quantity,
      alreadyPaidQuantity: 0,
      alreadyPrintedQuantity: 0,
      appliedTaxes: [],
      orderContentCombination: this._refundedCombination(content.orderContentCombination),
      subContents: content.subContents?.map(subContent => this._refundedSubContent(subContent)),
    })
  }

  _refundedCombination (combination) {
    return combination
      ? {...combination, id: null}
      : null
  }

  _refundedSubContent (subContent) {
    return {
      ...subContent,
      id: null,
      quantity: -subContent.quantity,
    }
  }

  _refundedInvoice (invoice, refund, contents, voidReasons = []) {
    const refunded = new Invoice({
      ...invoice,
      ...refund,
      signature: null,
      extra_id: null,
      prefix: null,
      withoutPrefix: null,
      orderContentsIds: null,
      orderPayments: invoice.orderPayments
        ?.map((payment, index) => this._refundedPayment(payment, voidReasons[index])),
    })
    refunded._splitedOrderContents = contents
    refunded.order = this
    refunded.setSummary()

    return refunded
  }

  _refundedPayment (payment, voidReason = null) {
    return new Payment({
      ...payment,
      id: null,
      date: null,
      turn_id: $vm.$store.state.cashControl.turn?.id,
      invoice_id: null,
      payAmount: -payment.payAmount,
      tipAmount: -payment.tipAmount,
      change: 0,
      voidReason,
    })
  }
}
